import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20collage%20with%20various%20comic%20characters%20in%20dynamic%20poses%2C%20warm%20golden%20and%20soft%20pink%20gradient%20background%2C%20artistic%20color%20splashes%2C%20modern%20webtoon%20aesthetic%2C%20clean%20composition%20with%20ample%20negative%20space%2C%20vibrant%20yet%20soft%20color%20palette&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫网 - 韩国漫画大全"
          title="韩漫网 韩国漫画大全 热门推荐"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="flex flex-col lg:flex-row items-center max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-24 lg:py-32 gap-10">
          <div className="w-full lg:w-[40%] text-center lg:text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
              探索最精彩的
              <br />
              <em className="not-italic text-primary-300">韩国漫画世界</em>
            </h1>
            <p className="mt-5 text-sm md:text-base text-background-200/90 max-w-md mx-auto lg:mx-0 leading-relaxed">
              韩漫网汇集最新热门韩漫推荐和最火排行榜，大全作品免费阅读，在线观看无限制，下拉式设计让您轻松探索多样内容。
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <Link
                to="/category/all"
                className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300 text-sm"
              >
                立即开始阅读
              </Link>
              <Link
                to="/category/romance"
                className="px-8 py-3 border border-background-300/60 text-background-50 font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-all duration-300 text-sm"
              >
                查看排行榜
              </Link>
            </div>
          </div>

          <div className="w-full lg:w-[60%]">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20featured%20display%20showing%20popular%20comic%20covers%20arranged%20in%20a%20beautiful%20grid%20layout%2C%20warm%20ambient%20lighting%2C%20clean%20modern%20presentation%2C%20colorful%20comic%20art%20covers%20with%20various%20genres%2C%20elegant%20showcase%20style&width=1000&height=600&seq=hero-showcase-2026&orientation=landscape"
                alt="热门韩国漫画推荐展示"
                title="韩漫网 最火韩国漫画排行榜 漫画大全"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full bg-background-50/95 backdrop-blur-sm">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-4 flex flex-wrap items-center justify-center gap-6 md:gap-8">
          <div className="flex items-center gap-2">
            <span className="text-2xl md:text-3xl font-heading font-bold text-primary-600">5000+</span>
            <span className="text-xs text-foreground-500">漫画作品</span>
          </div>
          <div className="w-px h-6 bg-background-300 hidden md:block"></div>
          <div className="flex items-center gap-2">
            <span className="text-2xl md:text-3xl font-heading font-bold text-accent-600">98.5%</span>
            <span className="text-xs text-foreground-500">读者满意度</span>
          </div>
          <div className="w-px h-6 bg-background-300 hidden md:block"></div>
          <div className="flex items-center gap-2">
            <span className="text-2xl md:text-3xl font-heading font-bold text-primary-600">1.2亿+</span>
            <span className="text-xs text-foreground-500">月阅读量</span>
          </div>
          <div className="w-px h-6 bg-background-300 hidden md:block"></div>
          <div className="flex items-center gap-2">
            <span className="text-2xl md:text-3xl font-heading font-bold text-accent-600">8大</span>
            <span className="text-xs text-foreground-500">漫画分类</span>
          </div>
        </div>
      </div>
    </section>
  );
}